<template>
  <v-dialog
    v-model="dialog"
    width="500"
    :hide-overlay="hideOverlay"
    persistent
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title class="baseColor">
        <v-icon
          class="mr-3"
          dark
          left
          v-text="$getIcon('mdiCloudUpload')"
        ></v-icon>
        <span class="white--text" v-text="'Upload Image'"></span>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-col v-if="showImg && !showCroppie">
          <v-img
            :class="profile ? 'profile-picture my-4' : ''"
            :src="cropped"
            :width="cover ? '500' : '300'"
            class="mx-auto"
            contain
          ></v-img>
        </v-col>
        <v-col v-if="showCroppie" class="pa-0">
          <image-croppie
            ref="croppieRef"
            :enable-resize="false"
            :viewport="getViewPort"
            :boundary="{ height: 250, width: '100%' }"
            @result="result"
          ></image-croppie>
          <v-divider></v-divider>
        </v-col>
        <v-col v-if="!image && !showCroppie" class="text-center">
          <div>
            <v-icon
              size="100"
              color="shade"
              v-text="$getIcon('mdiFile')"
            ></v-icon>
          </div>
          <div class="grey--text">
            Browse a file from here
          </div>
        </v-col>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="primaryLight">
        <v-spacer></v-spacer>
        <input
          ref="image"
          type="file"
          class="d-none"
          accept="image/*"
          @change="upload"
        />
        <v-btn
          v-if="!cropStatus && showCroppie"
          text
          color="primary"
          @click="crop"
        >
          Crop
        </v-btn>
        <v-btn v-if="cropped" text color="primary" @click="update">
          Update
        </v-btn>
        <v-btn v-if="!image" text color="primary" @click="pickFile">
          Browse
        </v-btn>
        <v-btn v-else text @click="reset">
          Reset
        </v-btn>
        <v-btn text @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { VueCroppieComponent as ImageCroppie } from "vue-croppie";
import "croppie/croppie.css";
export default {
  props: {
    cover: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Boolean,
      default: false
    },
    // Temporary fix carried out for overlay issue when v-dialog is present inside another v-dialog
    hideOverlay: {
      type: Boolean,
      default: false
    }
  },
  components: { ImageCroppie },
  data() {
    return {
      dialog: true,
      image: "",
      showCroppie: false,
      cropped: "",
      cropStatus: false,
      showImg: false,
      fileName: "",
      options: {
        format: "jpeg",
        circle: false,
        size: "original"
      },
      checkbox: true
    };
  },
  computed: {
    getViewPort() {
      if (this.cover) {
        return { width: "100%", height: 200, type: "square" };
      } else if (this.profile) {
        return { width: 200, height: 200, type: "circle" };
      } else {
        return { width: 200, height: 200, type: "square" };
      }
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    upload(file) {
      const reader = new FileReader();
      this.fileName = file.target.files[0].name;
      reader.readAsDataURL(file.target.files[0]);
      this.showCroppie = true;
      reader.onload = () => {
        this.$refs.croppieRef.bind({
          url: reader.result
        });
        this.image = reader.result;
        file.target.value = null;
      };
    },
    crop() {
      this.$refs.croppieRef.result(this.options, output => {
        this.cropped = output;
      });
      this.showCroppie = false;
      this.cropStatus = false;
      this.showImg = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
      this.reset();
    },
    update() {
      this.$emit("croppedImage", this.cropped);
      this.$emit("input", this.cropped);
      this.dialog = false;
      this.reset();
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const blob = new Blob([u8arr], { type: mime });
      blob.name = this.fileName;
      return blob;
    },
    result(output) {
      this.cropped = output;
    },
    reset() {
      this.cropped = null;
      this.cropStatus = false;
      this.showImg = false;
      this.showCroppie = false;
      this.image = "";
      this.fileName = "";
    }
  }
};
</script>
<style scoped>
.profile-picture {
  border-radius: 100%;
}
</style>
